
<script>

import { defineComponent } from 'vue'

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

import OneDocumentToComponent from './modalsEditor/documentToComponent'

//data
import { getDocumentPreview } from '@/services/serviceDocument';

export default defineComponent({
  name: 'ComponentDocument',
  mixins: [ MixinGeneralFunct ],
	data() {
		return {
			result: [],
			document: [],
			documentId: '',
			workContent:{},
			paddingBottom: 0
			,modalDocumentToArticleID:''
			,documentToArticleMODAL:{}
		}
	},
  props: {
	'content': Object
  },
  emits: ["content","changeContent"],
  components: {
    OneDocumentToComponent
  }
	,mounted () {
		
		this.documentId=this.content.fields.documentId;
		this.workContent = this.content;

		if(this.content.fields.paddingBottom){
			this.paddingBottom=this.content.fields.paddingBottom;
		}
		
		this.loadPreview();

		this.modalDocumentToArticleID = `modal${this.getRandomInt(999999999)}`;
	},
  
	methods: {
	
		//modal box select documents to article
		loadModalFormSelectDocument:function(){
			this.documentToArticleMODAL = new bootstrap.Modal(document.getElementById(this.modalDocumentToArticleID), {backdrop:'static'})
			this.documentToArticleMODAL.show();
		},

		loadPreview:function(){
			
			if(this.workContent.fields.documentId){

				getDocumentPreview({documentId:this.workContent.fields.documentId}).then(response => {
					if(!response.statusText){
						this.document = response.document;
					}else{
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
				
			}else{
				this.document=[];
			}
		
		},

		sendContent:function(){
			this.workContent.content = JSON.stringify(this.workContent.fields);
			this.$emit('changeContent', this.workContent)
		},

		onChangeDocumentId:function(){
			this.workContent.fields.documentId=this.documentId;
			this.sendContent();
		},

		onChangePaddingBottom:function(){
			console.log(this.paddingBottom)
			this.workContent.fields.paddingBottom=this.paddingBottom;
			this.sendContent();
		},

		//akcia po vybere fotky
		reloadAfterSelect(e) {
			this.documentId=e;
			this.onChangeDocumentId();
			this.loadPreview();
		},

	},
	
	watch: {
	
	},
	
	created() {

	}
})
</script>

<template>
  <div>
   
		<div class="col-12 mb-2 col-md-4">
			
				<button type="button" v-on:click="loadModalFormSelectDocument()" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnSelectDocument') }}</button>
			
		</div>

		<div class="col-12 col-md-4">
			<label><b>{{ $t('msgCore.paddingBottom') }}</b></label><br>
			
			<div v-for="(option) in 5" :key="option" class="form-check-inline">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" :name="`paddingBottom${documentId}`" v-model='paddingBottom' v-on:change="onChangePaddingBottom()" :value="option">
					{{ option }}
					<span class="circle">
						<span class="check"></span>
					</span>
				</label>
			</div>
			
		</div>

		<div class="col-12">
			
				<a :href="document.url" :title="document.title">{{ document.title }}</a>
			
		</div>

		<OneDocumentToComponent  :modalId="modalDocumentToArticleID" @changeAfterSelect="reloadAfterSelect" :modalObject="documentToArticleMODAL"></OneDocumentToComponent>
  </div>
</template>